import { useStytch } from "@stytch/react";
import { Button } from "../ui/button";
import googleLogo from "../../assets/g.webp";
import msLogo from "../../assets/ms.webp";
import apLogo from "../../assets/a.svg";

interface OAuthProps {
  returnTo?: string;
}

export default function OAuth({ returnTo = "/" }: OAuthProps) {
  const stytchClient = useStytch();

  const getOAuthOptions = () => {
    if (returnTo !== "/") {
      return {
        login_redirect_url: `${import.meta.env.VITE_DOMAIN}/authenticate?returnTo=${encodeURIComponent(returnTo)}`,
        signup_redirect_url: `${import.meta.env.VITE_DOMAIN}/authenticate?returnTo=${encodeURIComponent(returnTo)}`,
      };
    }
    return undefined;
  };

  return (
    <div
      id="stytch-oauth-buttons"
      className="flex flex-row items-center justify-center gap-2 mt-4"
    >
      <Button
        variant="secondary"
        type="button"
        onClick={() => stytchClient.oauth.google.start(getOAuthOptions())}
      >
        <img src={googleLogo} alt="Google" className="w-5 h-5" />
      </Button>
      <Button
        variant="secondary"
        type="button"
        onClick={() => stytchClient.oauth.microsoft.start(getOAuthOptions())}
      >
        <img src={msLogo} alt="Microsoft" className="w-5 h-5" />
      </Button>
      <Button
        variant="secondary"
        type="button"
        onClick={() => stytchClient.oauth.apple.start(getOAuthOptions())}
      >
        <img src={apLogo} alt="Apple" className="h-5" />
      </Button>
    </div>
  );
}
